<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header">
        <el-row>
          <el-col :span="12">
            <h3>定期宝</h3>
          </el-col>
          <el-col :span="6" :offset="6" style="text-align: right">
            <el-button size="mini" type="danger" @click="movein">转入</el-button>
            <el-button size="mini" type="primary" @click="moveout">转出</el-button>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col :span="4" class="capital">
          <h5>当前余额</h5>
          <p>{{ account.movableamount }}港元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>已投资额</h5>
          <p>{{ useamount.toFixed(2) }}港元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>当前资产</h5>
          <p>{{ account.amount }}港元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>当月收益</h5>
          <p>{{ account.interestthis }}港元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>上月收益</h5>
          <p>{{ account.interestlast }}港元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>历史收益</h5>
          <p>{{ account.interestamount }}港元</p>
        </el-col>
      </el-row>
      <el-form ref="regular" :model="regular" label-width="80px">
        <el-form-item label="金额:">
          <el-input v-model="regular.money" size="small" placeholder="请输入投资额度" style="width: 40%"
                    oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="multiple_box" v-for="(item,index) in financetype" :key="index">
            <div class="multiple" :class="{active_multiple:cut===index}" @click="setCut(index,item)">
              <a href="javascript:void(0);">
                <p>{{ item.name }}</p>
                <p>{{ item.period }}{{ (Number(item.interest)*100).toFixed(2) }}%</p>
                <p>收益{{ (Number(regular.money)*Number(item.interest)).toFixed(2) }}港元</p>
              </a>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" style="width: 200px;" @click="createFinance">确定</el-button>
        </el-form-item>
        <el-form-item label="温馨提示:">
          <p>可时时结算并转出提现，若未到期提前结算将不会有任何利息到账。</p>
        </el-form-item>
      </el-form>
      <el-tabs stretch>
        <el-tab-pane label="当前投资">
          <el-table
            :data="currentData"
            style="width: 100%"
            size="small"
            stripe>
            <el-table-column
              prop="order"
              align="center"
              label="定期宝编号">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="投资金额">
            </el-table-column>
            <el-table-column
              prop="period"
              align="center"
              label="投资周期">
            </el-table-column>
            <el-table-column
              prop="starttime"
              align="center"
              label="开始时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="endtime"
              align="center"
              label="结束时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="estimateinterest"
              align="center"
              label="预估收益">
            </el-table-column>
            <el-table-column
              align="center"
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="closefund(scope.row)">结算</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="历史投资">
          <el-table
            :data="historyData"
            style="width: 100%"
            size="small"
            stripe>
            <el-table-column
              prop="order"
              align="center"
              label="定期宝编号">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="投资金额">
            </el-table-column>
            <el-table-column
              prop="period"
              align="center"
              label="投资周期">
            </el-table-column>
            <el-table-column
              prop="starttime"
              align="center"
              label="开始时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="endtime"
              align="center"
              label="结束时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="realinterest"
              align="center"
              label="实际收益">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="资金明细">
          <el-form :inline="true" size="mini">
            <el-form-item label="委托日期">
              <el-date-picker
                v-model="capitalDetails.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getCapitalDetails">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="capitalDetails.data"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="资金">
            </el-table-column>
            <el-table-column
              prop="balance"
              align="center"
              label="余额">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              label="时间">
            </el-table-column>
          </el-table>
          <div class="changePage">
            <el-button type="primary" icon="el-icon-arrow-left" @click="prevCapital" size="mini">上一页</el-button>
            <el-button type="primary" icon="el-icon-arrow-right" @click="nextCapital" size="mini" style="float: right">
              下一页
            </el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: "FinanceFund",
    data() {
      return {
        regular: {
          money: 0
        },
        account: {
          amount: '0.00',
          movableamount: '0.00',
          totalamount: '0.00',
          interestamount: '0.00',
          interestthis: '0.00',
          interestlast: '0.00',
        },
        financetype: [],
        cut: 0,
        currentData: [],
        tid: 0,
        historyData: [],
        capitalDetails: {
          date: [],
          data: [],
          page: 1,
          num: 20
        }
      }
    },
    computed: {
      useamount: function () {
        let that = this;
        return Number(that.account.amount) - Number(that.account.movableamount);
      },
      earnings:function () {
        let that = this;
      }
    },
    methods: {
      getFinanceFund() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "finance_fund",
              token: sessionStorage.getItem("token"),
              action: 'queryfund'
            }
          })
          .then(function (res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.account = resData.data.account;
              that.financetype = resData.data.financetype;
              that.currentData = resData.data.details;
              that.tid = that.financetype[that.cut].tid
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      setCut(index, data) {
        this.cut = index;
        this.tid = data.tid;
      },
      createFinance() {
        let that = this;
        let money = parseInt(that.regular.money);
        if (money < 0 || isNaN(money)) {
          that.$message.error('填写金额不正确');
        } else {
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "finance_fund",
                token: sessionStorage.getItem("token"),
                action: 'createaccount',
                amount: that.regular.money,
                financetypeid: that.tid
              }
            })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                that.$message({
                  type: 'success',
                  message: resData.msg,
                  onClose: function () {
                    that.getFinanceFund();
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        }

      },
      closefund(data) {
        let that = this;
        this.$confirm('您的定期宝还没到期,提前结算您将损失所有的利息', '定期宝结算', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "finance_fund",
                token: sessionStorage.getItem("token"),
                action: 'closefund',
                financedetailid: data.id
              }
            })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                that.$message({
                  type: 'success',
                  message: resData.msg,
                  onClose: function () {
                    that.mainMethod();
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        }).catch(() => {

        });
      },
      getquerydetails() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "finance_fund",
              token: sessionStorage.getItem("token"),
              action: 'querydetails',
              status: '2'
            }
          })
          .then(function (res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.historyData = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      getCapitalDetails() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "finance_fund",
              token: sessionStorage.getItem("token"),
              action: 'querylog',
              page: that.capitalDetails.page,
              num: that.capitalDetails.num,
              start: that.capitalDetails.date[0],
              end: that.capitalDetails.date[1]
            }
          })
          .then(function (res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.capitalDetails.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      prevCapital() {
        let page = this.capitalDetails.page;
        if (page == 1) {
          this.$message({
            message: '已经是第一页',
            type: 'warning'
          });
        } else {
          this.capitalDetails.page = page - 1;
          this.getCapitalDetails();
        }
      },
      nextCapital() {
        let page = this.capitalDetails.page;
        if (this.capitalDetails.data.length < 20) {
          this.$message({
            message: '已经是最后一页',
            type: 'warning'
          });
        } else {
          this.capitalDetails.page = page + 1;
          this.getCapitalDetails();
        }
      },
      moveout(){
        this.$prompt('请输入转出金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\d+$/,
          inputErrorMessage: '金额不正确'
        }).then(({ value }) => {
          let that = this;
          let money = parseInt(value);
          if (money <= 0 || isNaN(money)){
            this.$message({
              type: 'warning',
              message: '请输入正确金额'
            });
            return false;
          }else{

            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "finance_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'moveout',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: 'success',
                    onClose:function () {
                      that.mainMethod();
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
          }


        }).catch(() => {
        });
      },
      movein(){
        this.$prompt('请输入转入金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\d+$/,
          inputErrorMessage: '金额不正确'
        }).then(({ value }) => {
          let that = this;
          let money = parseInt(value);
          if (money <= 0 || isNaN(money)){
            this.$message({
              type: 'warning',
              message: '请输入正确金额'
            });
            return false;
          }else{

            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "finance_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'movein',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: 'success',
                    onClose:function () {
                      that.mainMethod();
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
          }

        }).catch(() => {
        });
      },
      mainMethod(){
        this.getFinanceFund();
        this.getquerydetails();
        this.getCapitalDetails();
      },
    },
    mounted: function () {
      this.getFinanceFund();
      this.getquerydetails();
      this.getCapitalDetails();
    },
  }
</script>

<style scoped>
  .capital {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .capital h5 {
    color: #999;
    font-size: 14px;
    font-weight: 300;
  }

  .capital p {
    color: red;
    font-size: 14px;
    font-weight: bold;
  }

  .multiple_box {
    width: 19%;
    float: left;
    margin-right: 1.25%;
  }

  .multiple_box:last-child {
    margin-right: 0;
  }

  .multiple_box p {
    line-height: 1.5;
    font-weight: bold;
    font-size: 18px;
    color: #909399;
  }

  .multiple {
    background: white;
    border: 1px solid #666;
    border-radius: 4px;
    padding: 20px 0;
    text-align: center;
  }

  .active_multiple {
    background: #f56c6c;
    color: #fff !important;
    border: 1px solid #f56c6c !important;
  }

  .active_multiple p {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/FinanceFund.vue